import { AppUserId } from "../types/AppUser";
import { BankId } from "../types/banks/Bank";
import { BankAccount } from "../types/banks/BankAccount";
import { UserBank, UserBankId } from "../types/banks/UserBank";
import { PlaidLinkOnSuccessMetadata, PlaidAccount } from "react-plaid-link";

/**
 * Creates a UserBank entity from Plaid's Link Success Metadata.
 */
export const createUserBankFromPlaidMetadata = (
  appUserId: AppUserId,
  plaidMetadata: PlaidLinkOnSuccessMetadata,
): UserBank => {
  if (!plaidMetadata.institution) {
    throw new Error("Plaid metadata institution is required");
  }

  const bankId: BankId = plaidMetadata.institution.institution_id;
  const userBankId: UserBankId = `${appUserId}-${bankId}`;

  return {
    userBankId,
    appUserId,
    bankId,
  };
};

/**
 * Creates an array of BankAccount entities from Plaid's accounts data.
 */
export const createBankAccountsFromPlaidMetadata = (
  userBankId: UserBankId,
  appUserId: AppUserId,
  bankId: BankId,
  plaidAccounts: PlaidAccount[],
): BankAccount[] => {
  return plaidAccounts.map((plaidAccount) => ({
    accountId: plaidAccount.id,
    userBankId: userBankId,
    appUserId: appUserId,
    bankId: bankId,
    name: plaidAccount.name,
    mask: plaidAccount.mask,
    type: plaidAccount.type,
    subType: plaidAccount.subtype,
    verificationStatus: plaidAccount.verification_status ?? "",
  }));
};
